"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _formatters = require("../utils/formatters");

var Pricing = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(Pricing, _Record);

  function Pricing(values) {
    (0, _classCallCheck2.default)(this, Pricing);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Pricing).call(this, (0, _formatters.cleanObject)(values)));
  }

  return Pricing;
}((0, _immutable.Record)({
  planType: 'FREE',
  cents: 0,
  commitmentCents: 0,
  extraCharges: '',
  freeTrialDays: 0,
  name: '',
  tagline: '',
  features: '',
  updatedAt: null
}));

exports.default = Pricing;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/records/Pricing.js
// module id = 379
// module chunks = 209 210 211 212